import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/article/${movie.id}`}
      className="group block rounded-xl overflow-hidden bg-background-100 border border-background-200/50 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
    >
      <div className="relative aspect-[2/3] overflow-hidden">
        <img
          src={movie.poster}
          alt={movie.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2">
          <span className="inline-block px-2 py-0.5 rounded-md bg-accent-500/90 text-foreground-50 text-xs font-medium">
            {movie.rating}
          </span>
        </div>
        {movie.isNew && (
          <div className="absolute top-2 right-2">
            <span className="inline-block px-2 py-0.5 rounded-md bg-primary-500/90 text-background-950 text-xs font-medium">
              NEW
            </span>
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-4">
          <span className="inline-flex items-center gap-1 px-4 py-2 bg-primary-500 rounded-full text-background-950 text-xs font-semibold whitespace-nowrap">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-play-fill text-xs"></i>
            </div>
            立即观看
          </span>
        </div>
      </div>
      <div className="p-3">
        <h4 className="text-sm font-medium text-foreground-100 truncate mb-1 font-heading">
          {movie.title}
        </h4>
        <div className="flex items-center gap-2 text-xs text-foreground-500">
          <span>{movie.year}</span>
          <span className="text-foreground-700">·</span>
          <span>{movie.area}</span>
        </div>
        <div className="flex flex-wrap gap-1 mt-2">
          {movie.tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="inline-block px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-900 text-xs"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}